import { render, staticRenderFns } from "./userList.vue?vue&type=template&id=336cd4b9&"
import script from "./userList.vue?vue&type=script&lang=ts&"
export * from "./userList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports